<template>
  <div v-if="isOpen" class="fixed inset-0 top-[-1rem] bg-black bg-opacity-50 flex items-center justify-center z-50 w-full h-full p-8">
    <div class="bg-white dark:bg-dark-box-bg rounded-lg shadow-lg w-full max-w-lg p-6 relative dark:border dark:border-dark-border dark:text-dark-text max-h-[90vh] overflow-y-auto" ref="modal" :style="modalStyle">
      <!-- <h2 class="text-2xl font-semibold mb-6 text-gray-800 dark:text-dark-text">Dodaj nową firmę</h2> -->
      <div 
        class="cursor-move mb-4 pb-2 border-b dark:border-dark-border"
        @mousedown="startDrag"
        @touchstart="startDrag"
      >
        <h2 class="text-2xl font-bold text-gray-800 dark:text-dark-text">Dodaj nową firmę</h2>
      </div>
      <button @click="closeModal" class="absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:text-dark-text dark:hover:text-dark-border-hover">
        &times;
      </button>
      <form @submit.prevent="submitCreate" class="space-y-6">

        <!-- Nazwa firmy -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1">Nazwa firmy <span class="text-red-600">(*)</span>:</label>
          <input
              v-model="localCompany.companyName"
              type="text"
              class="block w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.companyName }"
              @input="validateField('companyName')"
          />
          <span v-if="localErrors.companyName" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.companyName }}</span>
        </div>

        <!-- NIP -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1">NIP <span class="text-red-600">(*)</span>:</label>
          <input
              v-model="localCompany.companyNip"
              type="text"
              class="block w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.companyNip }"
              @input="validateField('companyNip')"
          />
          <span v-if="localErrors.companyNip" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.companyNip }}</span>
        </div>

        <!-- Adres -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1">Adres <span class="text-red-600">(*)</span>:</label>
          <input
              v-model="localCompany.companyAddress"
              type="text"
              class="block w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.companyAddress }"
              @input="validateField('companyAddress')"
          />
          <span v-if="localErrors.companyAddress" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.companyAddress }}</span>
        </div>

        <!-- Telefon -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1">Telefon <span class="text-red-600">(*)</span>:</label>
          <input
              v-model="localCompany.phone"
              type="text"
              class="block w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.phone }"
              @input="validateField('phone')"
          />
          <span v-if="localErrors.phone" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.phone }}</span>
        </div>

        <!-- Checkbox: Aktywna firma -->
        <div>
          <!-- <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1">Status firmy:</label> -->
          <div class="flex items-center">
            <input
                v-model="localCompany.onlyAB"
                type="checkbox"
                class="h-5 w-5 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded dark:bg-dark-box-bg dark:border-dark-border"
            />
            <label class="ml-2 text-sm text-gray-700 dark:text-dark-text">Tylko AB</label>
          </div>
          <span v-if="localErrors.onlyAB" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.onlyAB }}</span>
        </div>

        <div>
          <!-- <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1">Status firmy:</label> -->
          <div class="flex items-center">
            <input
                v-model="localCompany.extendedInvoice"
                type="checkbox"
                class="h-5 w-5 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded dark:bg-dark-box-bg dark:border-dark-border"
            />
            <label class="ml-2 text-sm text-gray-700 dark:text-dark-text">Rozserzona faktura</label>
          </div>
          <span v-if="localErrors.extendedInvoice" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.extendedInvoice }}</span>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1">Inicjały:</label>
          <input
              v-model="localCompany.initials"
              type="text"
              class="block w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.initials }"
          />
          <span v-if="localErrors.initials" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.initials }}</span>
        </div>

        <!-- Submit -->
        <div class="flex justify-end">
          <button 
              type="submit"
              :disabled="!isFormValid"
              class="w-full bg-button-bg text-button-text py-2 rounded-md hover:bg-button-hover focus:outline-none focus:ring focus:ring-indigo-500 dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
              :class="{ 'opacity-50 cursor-not-allowed': !isFormValid }"
          >
            Dodaj firmę
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
/* Pasek przewijania w trybie ciemnym */
.dark .overflow-y-auto::-webkit-scrollbar {
  width: 8px; /* Szerokość paska przewijania */
}

.dark .overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #2c7a7a; /* Teal-700 */
  border-radius: 8px; /* Zaokrąglenie suwaka */
  border: 2px solid #1a5d5d; /* Ciemniejszy odcień teal dla krawędzi suwaka */
}

.dark .overflow-y-auto::-webkit-scrollbar-track {
  background-color: #333333; /* Ciemne tło dla śledzenia paska */
  border-radius: 8px; /* Zaokrąglenie tła paska */
}

/* Pasek przewijania w trybie jasnym */
.overflow-y-auto::-webkit-scrollbar {
  width: 8px; /* Szerokość paska przewijania */
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #d1d5db; /* Jasnoszary kolor suwaka (szary) */
  border-radius: 8px; /* Zaokrąglenie suwaka */
  border: 2px solid #9ca3af; /* Ciemniejszy szary dla krawędzi suwaka */
}

.overflow-y-auto::-webkit-scrollbar-track {
  background-color: #f3f4f6; /* Jasnoszare tło dla śledzenia paska */
  border-radius: 8px; /* Zaokrąglenie tła paska */
}

.cursor-move {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.dragging {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>

<script>
export default {
  props: {
    isOpen: Boolean
  },
  data() {
    return {
      localCompany: {
        companyName: '',
        companyNip: '',
        companyAddress: '',
        phone: '',
        onlyAB: false,
        extendedInvoice: true,
        initials: ''
      },
      localErrors: {
        companyName: '',
        companyNip: '',
        companyAddress: '',
        phone: '',
        onlyAB: '',
        extendedInvoice: '',
        initials: ''
      },
      isDragging: false,
      dragOffset: { x: 0, y: 0 },
      modalPosition: { x: 0, y: 0 }
    };
  },
  computed: {
    isFormValid() {
      // Sprawdza, czy wszystkie błędy są puste
      const noErrors = Object.values(this.localErrors).every(error => error === '');

      // Sprawdza, czy wszystkie wymagane pola są wypełnione
      const allFieldsFilled = this.localCompany.companyName &&
                              this.localCompany.companyNip &&
                              this.localCompany.companyAddress &&
                              this.localCompany.phone;

      return noErrors && allFieldsFilled;
    },
    modalStyle() {
      return {
        transform: `translate(${this.modalPosition.x}px, ${this.modalPosition.y}px)`
      };
    }
  },
  methods: {
    /**
     * @note Zamyka modal, emitując zdarzenie 'close' do komponentu nadrzędnego.
     * @return {void}
     */
    closeModal() {
      this.$emit('close');
    },

    /**
     * @note Waliduje pole formularza dotyczące danych firmy, ustawiając odpowiednie komunikaty błędów, jeśli dane są niepoprawne.
     * @param {string} field - Nazwa pola, które ma być zwalidowane (np. 'companyName', 'companyNip', 'companyAddress', 'phone').
     * @return {void}
     */
    validateField(field) {
      const company = this.localCompany;
      switch (field) {
        case 'companyName':
          this.localErrors.companyName = company.companyName.length < 3 ? 'Nazwa firmy musi mieć co najmniej 3 znaki' : '';
          break;
        // case 'companyNip':
        //   this.localErrors.companyNip = !/^\d{10}$/.test(company.companyNip) ? 'NIP musi składać się z 10 cyfr' : '';
        //   break;
        case 'companyAddress':
          this.localErrors.companyAddress = company.companyAddress === '' ? 'Adres firmy jest wymagany' : '';
          break;
        case 'phone':
          this.localErrors.phone = company.phone.length < 9 ? 'Numer telefonu musi składać mieć min. 9 cyfr' : '';
          break;
      }
    },

    /**
     * @note Waliduje wszystkie pola formularza przed dodaniem nowej firmy. Jeśli walidacja jest poprawna, emituje zdarzenie 'submit' z obiektem `localCompany`.
     * @return {void}
     */
    submitCreate() {
      this.validateField('companyName');
      //this.validateField('companyNip');
      this.validateField('companyAddress');
      this.validateField('phone');

      if (!this.hasErrors) {
        this.$emit('submit', this.localCompany);

        this.localCompany = {
          companyName: '',
          companyNip: '',
          companyAddress: '',
          phone: '',
          onlyAB: false,
          extendedInvoice: false,
          initials: ''
        };
        this.localErrors = {
          companyName: '',
          companyNip: '',
          companyAddress: '',
          phone: '',
          onlyAB: '',
          extendedInvoice: '',
          initials: ''
        };
      }
    },
    startDrag(event) {
        this.isDragging = true;
        
        event.currentTarget.classList.add('dragging');

        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.dragOffset.x = clientX - this.modalPosition.x;
        this.dragOffset.y = clientY - this.modalPosition.y;
        
        // Dodajemy event listeners
        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('touchmove', this.onDrag, { passive: false });
        document.addEventListener('mouseup', this.stopDrag);
        document.addEventListener('touchend', this.stopDrag);
      },
    onDrag(event) {
        if (!this.isDragging) return;
        
        event.preventDefault();
        
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.modalPosition.x = clientX - this.dragOffset.x;
        this.modalPosition.y = clientY - this.dragOffset.y;
      },
    stopDrag() {
        this.isDragging = false;
        
        const dragElement = document.querySelector('.cursor-move');
        if (dragElement) {
          dragElement.classList.remove('dragging');
        }

        // Usuwamy event listeners
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('touchmove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('touchend', this.stopDrag);
      },
    resetPosition() {
        this.modalPosition = { x: 0, y: 0 };
    },
  }
};
</script>
